/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_Sources_TermInputs */

const en_how_we_work_brief_sources_term = /** @type {(inputs: How_We_Work_Brief_Sources_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources`)
};

const lv_how_we_work_brief_sources_term = /** @type {(inputs: How_We_Work_Brief_Sources_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoti`)
};

/**
* | output |
* | --- |
* | "Sources" |
*
* @param {How_We_Work_Brief_Sources_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_sources_term = /** @type {((inputs?: How_We_Work_Brief_Sources_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_Sources_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_sources_term(inputs)
	return en_how_we_work_brief_sources_term(inputs)
});